import { palette } from '../themes/palette'

export const activeStyle = (status: string, condition: string) => {
  return {
    border: `1px ${status === condition ? '#D1C058' : '#666666'} solid`,
    color: `${status === condition ? '#D1C058' : '#666666'}`
  }
}

export const activeBorder = (status: boolean) => {
  return {
    border: `1px ${status ? '#D1C058' : '#999999'} solid`,
    color: `#000000`
  }
}

export function getColorBasedOnShift(shift: string) {
  const s = shift.toLowerCase()
  if (s.includes('on_call')) return '#FFF3C4'
  if (s.includes('morning')) return '#E7C4FF'
  if (s.includes('evening')) return '#C4FFDA'
  if (s.includes('night')) return '#C4F9FF'
  return palette.brand
}

export function getBorderColorBasedOnShift(shift: string) {
  const s = shift.toLowerCase()
  if (s.includes('on_call')) return '#FAE8AD'
  if (s.includes('morning')) return '#E2ADFA'
  if (s.includes('evening')) return '#ADFAC4'
  if (s.includes('night')) return '#ADE2FA'
  return palette.brand
}

export const getStatusStyle = (status: string = '') => {
  const lowerCaseStatus = status?.toLowerCase()

  switch (lowerCaseStatus) {
    case 'active':
    case 'completed':
    case 'administered':
      return { bg: '#EFFEE6', text: '#40B300' }
    case 'on_leave':
    case 'checked_in':
    case 'pending':
      return { bg: '#FFF8E5', text: '#FFB800' }
    case 'retired':
      return { bg: palette.sedonaSage, text: palette.squant }
    case 'resigned':
    case 'upcoming':
    case 'wasted':
      return { bg: palette.sapphire, text: palette.guardBlue }
    case 'ongoing':
      return { bg: '#FFF8E5', text: '#FFB800' }
    case 'onhold':
    case 'missed':
      return { bg: '#FEE6E6', text: '#FD1E1E' }
    case 'cancelled':
      return { bg: '#F2F2F2', text: palette.squant }
    case 'dismissed':
      return { bg: palette.carouselPink, text: palette.cranberrySplash }
    case 'on_notice_period':
      return { bg: palette.royalty, text: palette.chinesePurple }
    default:
      return {
        bg: '#eee',
        text: '#66666'
      }
  }
}
